import { render, staticRenderFns } from "./matchmakerList.vue?vue&type=template&id=435554fd&scoped=true"
import script from "./matchmakerList.vue?vue&type=script&lang=js"
export * from "./matchmakerList.vue?vue&type=script&lang=js"
import style0 from "./matchmakerList.vue?vue&type=style&index=0&id=435554fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435554fd",
  null
  
)

export default component.exports